<template>
  <swiper :options="swiperOptions" ref="mySwiper" :class="{'loading' : !swiperStarted}">
    <swiper-slide v-for="(slide, index) in gallery" :key="index" :class="`swiper-slide-${index}`" :style="{ backgroundImage: `url('${cUrl_part_1}${screenSize}${cUrl_part_2}${slide}')` }">
      <div class="fake-bg"></div>
    </swiper-slide>
    <div class="swiper-button-prev smalltxt" slot="button-prev">←</div>
    <div class="swiper-button-next smalltxt" slot="button-next">→</div>
    <div class="swiper-pagination smalltxt" slot="pagination"></div>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'SingleGallery',
  props: ['gallery'],
  data() {
    return {
      cUrl_part_1: 'https://res.cloudinary.com/dfrhbuipn/image/upload/w_',
      cUrl_part_2: '/v1541424180/',
      screenSize: '1000',
      swiperStarted: false,
      swiperOptions: {
        init: false,
        direction: 'horizontal',
        slideToClickedSlide: true,
        speed: 2000,
        effect: 'slide',
        spaceBetween: 30,
        pagination: {
          type: 'fraction',
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  methods: {
    startSwiper() {
      this.swiperStarted = true;
      this.swiper.init();
    },
    /* eslint-disable-next-line */
    closestNumber: function(array, num) {
      let minDiff = 1000;
      let ans;

      array.forEach(value => {
        const diff = Math.abs(num - value);
        if (diff < minDiff) {
          minDiff = diff;
          ans = value;
        }
      });

      return ans;
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  created() {},
  mounted() {
    const desiredSize = 0.8 * window.innerWidth;
    const sizes = [500, 750, 1000, 1500, 2000];
    let result = sizes.filter(number => number > desiredSize);
    if (result === undefined || result.length === 0) {
      result = [2000];
    }
    this.screenSize = String(this.closestNumber(result, desiredSize));
    setTimeout(this.startSwiper, 1500);
  },
  watch: {
    $route() {
      this.swiper.slideTo(0);
    },
  },
};
</script>

<style lang="scss">
// not scoped, otherwise impossible to overwrite swiper
@import '~@/styles/mixins.scss';
#app.projet {
  .swiper-container {
    height: auto;
    padding-bottom: 50px;
    z-index: 0;
    padding-right: 10%;
    margin-left: 0;
    &.loading {
      opacity: 0;
    }
    transition: opacity 0.5s ease-out;
    opacity: 1;
  }
  .swiper-slide {
    background-size: cover;
    background-position: center center;
    height: 100%;
    padding-top: 66.66%; // 3:2
    transition: opacity 0.2s ease-in-out;
  }
  .swiper-slide-next,
  .swiper-slide-prev {
    cursor: pointer;
  }
  .fake-bg {
    opacity: 0;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.05), rgba(255, 255, 255, 0.9));
    position: absolute;
    pointer-events: none;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    transition: opacity 2s ease;
  }
  .swiper-slide-next {
    .fake-bg {
      opacity: 1;
    }
    &:hover {
      opacity: 0.4;
    }
  }
  .swiper-pagination-fraction {
    bottom: 0px;
    right: 30px;
    left: auto;
    width: 40px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    background-image: none;
    top: auto;
    bottom: 0px;
    width: 16px;
    height: 20px;
    left: auto;
  }
  .swiper-button-next {
    right: 0px;
  }
  .swiper-button-prev {
    right: 80px;
  }
  @include sm {
    .swiper-container {
      padding-bottom: 30px;
      padding-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/SingleGallery.vue